import { createContext, useContext } from 'react'

import type { PropsWithChildren } from '../../types'
import type { CreateBroadcastInputs } from './broadcast.schema'

type Context = Pick<
  CreateBroadcastInputs,
  'messageType' | 'smsMessage' | 'emailMessage' | 'emailSubject'
> | null

const testBroadcastContext = createContext<Context>(null)

function useTestBroadcastPermissions() {
  const context = useContext(testBroadcastContext)
  if (!context) {
    throw new Error(
      'useTestBroadcastPermissions has to be used within <testBroadcastContext.Provider>'
    )
  }

  return context
}

function TestBroadcastProvider({
  children,
  value,
}: PropsWithChildren<{
  value: Context
}>) {
  return (
    <testBroadcastContext.Provider value={value}>
      {children}
    </testBroadcastContext.Provider>
  )
}

export { TestBroadcastProvider, useTestBroadcastPermissions }
